<script setup lang="ts">
    defineProps<{
        label?: string;
        id: string;
    }>();

    const model = defineModel<boolean>();
</script>
<template>
    <input
        :id="id"
        v-model="model"
        class="Toggle-checkbox"
        type="checkbox"
        :aria-label="label"
        :style="label ? { '--toggle-label': `'${label}'` } : {}"
    />
</template>
<style scoped>
    .Toggle-checkbox {
        background-color: var(--color-primary-acai);
        color: var(--color-primary-blueberry);
        border: none;
        border-radius: 0.25rem;
        width: 2.25rem;
        height: 2.25rem;
        content: 'Toggle';
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
    }
    .Toggle-checkbox:checked {
        background-color: var(--color-primary-blueberry);
        color: var(--color-primary-acai);
        background-image: none;
    }
    .Toggle-checkbox::after {
        content: var(--toggle-label, '');
    }
</style>
